module.exports = __webpack_public_path__ + "img/tutorial_classes_03.2d930f89.gif";